const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPluvio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61.758 80.166",
    width: 45,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    transform: "matrix(1, 0, 0, 1, -72.900375, -118.035004)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF",
      fillOpacity: 6565651,
      strokeWidth: 0.31139946
    },
    id: "ellipse-1",
    cx: 103.81137,
    cy: 149.10838,
    rx: 23.36812,
    ry: 24.166615
  }), /*#__PURE__*/React.createElement("g", {
    id: "g428",
    transform: "matrix(1.201118,0,0,1.1966959,53.043302,-41.029063)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#843993",
      strokeWidth: 0.26458332
    },
    d: "m 45.80052,171.54552 c -0.614722,-0.67926 -0.544544,-1.92545 0.167969,-2.98275 0.722788,-1.07254 1.151199,-1.12701 1.819899,-0.23136 0.757796,1.01499 0.924131,2.53701 0.346959,3.17478 -0.593508,0.65582 -1.759141,0.67545 -2.334827,0.0393 z m -9.789583,-4.23333 c -0.85774,-0.94779 -0.423368,-3.22685 0.83145,-4.36245 0.515015,-0.46608 0.549063,-0.4587 1.223458,0.26521 1.229482,1.31975 1.464332,3.232 0.513687,4.18265 -0.554022,0.55402 -2.034466,0.50479 -2.568595,-0.0854 z m 4.324618,-6.10353 c -7.068231,-0.15494 -7.300715,-0.17709 -8.13993,-0.77567 -1.104787,-0.78799 -1.649654,-1.85162 -1.649654,-3.22028 0,-1.93275 1.476633,-3.77507 3.2999,-4.11711 0.745247,-0.13981 0.933833,-0.31505 1.079086,-1.00272 0.560092,-2.65163 3.405169,-4.30692 5.795541,-3.37191 0.370573,0.14495 0.838717,-0.0243 1.651006,-0.59683 0.87562,-0.6172 1.497912,-0.8255 2.733036,-0.91484 3.693421,-0.26716 6.305491,2.1591 6.354386,5.90237 0.01267,0.97047 0.103635,1.10243 1.095624,1.5895 2.572083,1.26291 2.688553,4.80502 0.200303,6.09175 -1.038456,0.537 -3.353044,0.61449 -12.419298,0.41574 z",
    id: "path430"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    transform: "matrix(1.2011179,0,0,1.1966959,-110.70892,-176.56689)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#843993",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    d: "m 177.18494,308.62307 c -0.37986,-0.20645 -1.18003,-1.18395 -1.77816,-2.17221 -1.55918,-2.57619 -3.28807,-4.66229 -8.3613,-10.08889 -5.14299,-5.50121 -7.091,-8.09086 -8.88857,-11.81629 -1.99051,-4.12531 -2.49415,-6.51818 -2.47809,-11.77396 0.0154,-5.02587 0.40009,-6.89426 2.21897,-10.77563 2.95125,-6.2978 8.26196,-10.75035 14.95072,-12.53482 2.78595,-0.74326 7.87851,-0.8257 10.60496,-0.17169 11.81843,2.83498 19.25365,13.92401 17.84507,26.61448 -0.82265,7.41157 -3.50157,12.21879 -11.49365,20.62492 -4.19968,4.41725 -6.84445,7.63334 -8.24074,10.02089 -1.36149,2.32803 -2.72374,2.97295 -4.37921,2.0732 z m 5.71322,-20.14542 c 5.85491,-1.5036 10.56563,-6.24065 12.19817,-12.26635 0.62016,-2.28901 0.62239,-6.43594 0.005,-8.70834 -1.64337,-6.04555 -6.45493,-10.75802 -12.5952,-12.33582 -2.3644,-0.60755 -7.13446,-0.41648 -9.45118,0.37857 -5.0802,1.74344 -9.09561,5.79976 -10.95614,11.06775 -0.7964,2.25497 -0.97263,6.63161 -0.36759,9.12898 1.64617,6.79474 7.31322,12.06351 14.16032,13.16514 1.82168,0.29308 4.93554,0.10203 7.00694,-0.42993 z",
    id: "path-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPluvio);
export default __webpack_public_path__ + "static/media/map_pluvio.24a9c90728b3340345c7d31a08ad18b0.svg";
export { ForwardRef as ReactComponent };